module.exports = __webpack_public_path__ + "static/media/csrd_dashboard_icon1.f7af5b93.svg";